module.exports = __webpack_public_path__ + "static/img/PDF报告@3x.c2c8c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/PDF报告@3x.png
// module id = 677
// module chunks = 382